<template>
  <div>
    <el-input
      :disabled="disabled"
      :value="materialQuantitySelect"
      class="input"
      type="number"
      @input="handleChangeMaterialQuantitiy($event)"
    ></el-input>
  </div>
</template>

<script>
import { Input } from "element-ui";

export default {
  components: {
    "el-input": Input
  },
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    materialQuantitySelect() {
      return this.value;
    },
  },
  methods: {
    handleChangeMaterialQuantitiy(value) {
      if (value) {
        this.$emit("input", +value);
      } else {
        this.$emit("input", value);
      }
    }
  }
};
</script>